export default "__VITE_ASSET__Drfk7cPp__"